import EnvHandler, {
  Environments as _Environments,
  WsHostDefaults as _WsHostDefaults,
  WsKeyDefaults as _WsKeyDefaults,
} from './env-handler-setup'

export const Environments = _Environments
export const WsHostDefaults = _WsHostDefaults
export const WsKeyDefaults = _WsKeyDefaults
export default { ...EnvHandler }
